<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="notification.notification_id && notification.notification_id > 0"
                            @invoke-method="dbGetNotification(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="notification.notification_id && notification.notification_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('notifications.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in notification_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != notification.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('notifications.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_notification.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'notifications' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="notification.status" class="ribbon ribbon-top-right" :class="`ribbon-${notification.status_class}`">
                            <span class="ribbon-span">{{ notification.status }}</span>
                        </div>
                        <v-form ref="formNotification">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="notification_dialog"
                                    v-model="notification.notification_id"
                                    :label="$t('lang.notification_id')"
                                    :counter="showCounter(notification.notification_id, 'notifications.notification_id')"
                                    :rules="ifValid('notifications.notification_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="notification.subject"
                                    :label="$t('lang.subject')"
                                    :counter="showCounter(notification.subject, 'notifications.subject')"
                                    :rules="ifValid('notifications.subject')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="notification.message"
                                    :label="`${$t('lang.message')} *`"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('notifications.message')"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="notification.object_name"
                                    :label="$t('lang.object_name')"
                                    :counter="showCounter(notification.object_name, 'notifications.object_name')"
                                    :rules="ifValid('notifications.object_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="notification.object_id"
                                    :label="$t('lang.object_id')"
                                    :counter="showCounter(notification.object_id, 'notifications.object_id')"
                                    :rules="ifValid('notifications.object_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="notification.modal"
                                    :label="$t('lang.modal')"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('notifications.modal')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="notification.file"
                                    :label="$t('lang.file')"
                                    :counter="showCounter(notification.file, 'notifications.file')"
                                    :rules="ifValid('notifications.file')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="notification.icon"
                                    :label="$t('lang.icon')"
                                    :counter="showCounter(notification.icon, 'notifications.icon')"
                                    :rules="ifValid('notifications.icon')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="notification.icon_class"
                                    :label="$t('lang.icon_class')"
                                    :counter="showCounter(notification.icon_class, 'notifications.icon_class')"
                                    :rules="ifValid('notifications.icon_class')"
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'notifications' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveNotifications">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_notification"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_notification')"
                :message="$t('lang.delete_notification_confirm')"
                @onConfirm="deleteNotifications()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_notification_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteNotificationDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            notification: {},
            file_name: "",
            dbGetNotification: _.debounce(this.getNotification, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchNotification", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.notification) {
                        this.notification = this.assignObj2(data.notification, this.rules_notifications);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=notification_status&sort_by=2",
                            method: "get",
                            stateProperty: "notification_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "notifications", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchNotification", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.notification) {
                        next((vm) => {
                            vm.notification = vm.assignObj2(data.notification, vm.rules_notifications);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=notification_status&sort_by=2",
                                method: "get",
                                stateProperty: "notification_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "notifications", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=notification_status&sort_by=2",
            method: "get",
            stateProperty: "notification_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_notifications: (state) => state.notifications.rules_notifications,
            notification_status_options: (state) => state.settings.notification_status_options,
            notifications: (state) => state.notifications.notifications,
            selectedNotification: (state) => state.notifications.selectedNotification,
        }),
    },
    methods: {
        ...mapActions(["fetchNotification", "saveNotification", "deleteNotification", "printNotification"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getNotification(pg_refresh = false) {
            this.startLoader();

            this.fetchNotification({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.notification) {
                    this.notification = this.assignObj2(data.notification, this.rules_notifications);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printNotification({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.notification) {
                    if (this.dev_mode) {
                        this.file_name = data.notification.file_name;
                    } else {
                        this.$refs.print.printReport(data.notification.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveNotifications() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formNotification")) {
                    let body = this.prepForm(this.notification, this.rules_notifications);

                    this.saveNotification({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.notification) {
                            this.$router.push({ name: "notification", params: { id: data.notification.notification_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { notification_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveNotifications({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.notification) {
                    this.notification = this.assignObj2(data.notification, this.rules_notifications);
                }
            });
        },
        deleteNotifications() {
            this.deleteNotification({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "notifications" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchNotification({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.notification) {
                        this.notification = this.assignObj2(data.notification, this.rules_notifications);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    created() {},
};
</script>
